<template>
  <div>
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-filter"></i>
          FAQ
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">Board</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">FAQ</a>
          </li>
      </ul>
    </div>
    <b-card>
      <b-row>
        <b-col>
          <b-input class="title" md="5" type="text" v-model="model.title" :plaintext="lock"></b-input>
        </b-col>
        <b-col>
          <span class="float-right font_13" v-if="!add">{{model.created_at | sdate}}</span>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="2" class="col-form-label">
          カテゴリー
        </b-col>
        <b-col>
          <b-input type="text" v-model="codes.BOARD_TYPE[model.type]" :disabled="lock"></b-input>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col md="2" class="col-form-label">
          Title <span class="text-danger ml-1">*</span>
        </b-col>
        <b-col>
          <b-input type="text" v-model="model.title" :disabled="lock"></b-input>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="title_sub">
          コンテンツ
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col>
          <vue-editor v-model="model.content" :disabled="lock" id="ph_content"></vue-editor>
        </b-col>
      </b-row>

      <!-- <div slot="header">
        <strong>FAQ</strong>
        <small v-if="!add"> ({{model.created_at | sdate}})</small>
      </div> -->
      <!-- <b-form-group>
        <label class="text-primary" for="ph_category">カテゴリー</label>
        <p>{{codes.BOARD_TYPE[model.type]}}</p>
      </b-form-group>
      <b-form-group class="text-primary">
        <label for="ph_title1">タイトル</label>
        <b-input md="5" type="text" id="ph_title" v-model="model.title" :plaintext="lock"></b-input>
      </b-form-group>
      <b-form-group>
        <label for="ph_content" class="text-primary">コンテンツ</label>
        <div v-if="lock" class="ql-editor ql-snow" v-html="model.content"></div>
        <vue-editor v-else v-model="model.content" id="ph_content"></vue-editor>
      </b-form-group> -->
      <hr>
      <b-button class="btn-addition float-right" size="sm" variant="secondary" @click="back"> リスト </b-button>
      <!-- <b-button size="sm" variant="secondary" @click="back"> リスト </b-button> -->
    </b-card>
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
